<template>
  <div>
    <div
      class="
        banner
        d-flex
        flex-column
        justify-content-md-center
        align-items-center
      "
      style="background-color: #1041a5"
    >
      <h1 class="mt-5 font-weight-light display-4">{{this.JobDesp.JobPositionName}}</h1>
      <div v-if="Object.keys(this.$route.params).length > 0">
        <span ><i class="fas fa-building"></i> CSI Group</span>
      </div>

      <div v-if="Object.keys(this.$route.params).length === 0" class="col-md-12">
        <p></p><p>We are always looking for bright minds and enthusiastic people from diverse backgrounds, who want to be part of an outstanding team. Even if you don’t find a suitable position below, please do not hesitate to drop us your resume.</p><p></p>
    </div>

    </div>

    <div class="container mt-4 mb-5 px-xl-5">


      <span v-for="(matched, idx) in this.$router.options.routes" :key="idx">

      <router-link v-if="idx === 0" :to="{ name: 'home' }" style="color:#1041A5;text-decoration: none;">
        Job Openings
      </router-link>

      <router-link v-if="idx === 1 && Object.keys(this.$route.params).length !=0" :to="{ name: 'jobview',params:{id: getJobPositionId} }" style="color:#1041A5;text-decoration: none;">
        {{ JobDesp.JobPositionName }}
      </router-link>

      <span v-if="idx === 2" class="text-secondary"> Apply </span>
      <span v-if="idx < 2"> > </span>
      </span>

      <div class="mt-5 pb-4">
        <div id="app" style="display: block">
          <div>
            <!---->
            <form @submit.prevent="handleSubmitForm" class="was-validated">
              <div class="form-group">
                <label for="">Full Name: <span>*</span></label>
                <div class="mb-3 mt-3">
                  <input
                    type="text"
                    placeholder="Full Name"
                    class="form-control"
                    v-model="ApplyData.FullName"
                    required />
                   
                    <div class="invalid-feedback">This field is required.</div>
                </div>
                <!---->
              </div>
              <div class="form-group">
                <label for="">Email: <span>*</span></label>
                <div>
                  <input
                    type="email"
                    placeholder="Email"
                    class="form-control"
                    v-model="ApplyData.Email"
                    required
                  />
                   <div class="valid-feedback">Valid.</div>
                    <div class="invalid-feedback">This field is required.</div>
                </div>
                <!---->
              </div>
              <div class="form-group">
                <label for="">Phone: <span>*</span></label>
                <div>
                  <input
                    type="text"
                    placeholder="Phone"
                    class="form-control"
                    v-model="ApplyData.Phone"
                    required
                  />
                
                    <div class="invalid-feedback">This field is required.</div>
                </div>
                <!---->
              </div>
              <div class="form-group">
                <label for=""
                  >Cover Letter:
                  <!----></label
                >
                <div>
                  <!---->
                  <textarea
                    placeholder="Cover Letter"
                    class="form-control"
                    v-model="ApplyData.ConverLetter"
                  ></textarea>
                </div>
                <!---->
              </div>
              <div class="form-group">
                <label for="">Resume: <span>*</span></label>
                <div
                  class="custom-file"
                  style="display: block; height: auto"
                >
                  <div class="mb-5">
                    <input
                      class="form-control"
                      type="file"
                      @change="imageUpload"
                      required
                    />

                    <div class="invalid-feedback">This field is required.</div>
                  </div>

                  <div><!----></div>
                </div>
           
                    <!-- <div class="invalid-feedback">This field is required.</div> -->
              </div>
              <div class="mt-3">
                <!---->
                <br />
                <!---->
                <br />
                <button
                  type="submit"
                  name="submit"
                  id="submit-id-submit"
                  class="btn btn-primary mt-4 btn btn-success btn-lg btn-apply"
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import variables from "@/variables";
import { useRoute } from "vue-router";

export default {
  components: {},
  setup() {
    const route = useRoute();

    return { route };
  },

  data() {
    return {
      JobDesp: [],
      ApplyData: {
        FullName: "",
        Email: "",
        Phone: "",
        ConverLetter: "",
        ResumeFile: "",
        RefJobKeyId: ""
      },
    };
  },
  methods: {
    handleSubmitForm() {
      console.log(variables.API_URL);

      var formData = new FormData();
      for (var key in this.ApplyData) {
        formData.append(key, this.ApplyData[key]);
      }

      console.log(formData);
      axios
        .post(variables.API_URL + "position/ApplyJobPosition", formData)
        .then(() => {
          this.$router.push("/");
          this.ApplyData = {
            FullName: "",
            Email: "",
            Phone: "",
            ConverLetter: "",
            ResumeFile: "",
            RefJobPosId: 0
          };

          alert('Successfully');
        })
        .catch((error) => {
          console.log(error);
        });
    },
    imageUpload(e) {
      
      this.ApplyData.ResumeFile = e.target.files[0];

    },
  },
  created() {


    if(Object.keys(this.$route.params).length===0)
    {

      this.JobDesp ={
        JobPositionName : "Submit your application"
      }

      
      document.title = this.JobDesp.JobPositionName + " CSI-GROUPS Open Position"
      return this.JobDesp
    }

    this.ApplyData.RefJobKeyId = this.$route.params.id;

  
  

    axios
      .get(
        variables.API_URL +
          "position/GetViewJobDescription/" +
          this.$route.params.id
      )
      .then((response) => {
        this.JobDesp = response.data[0];


        document.title = this.JobDesp.JobPositionName + " CSI-GROUPS Open Position"


      })
      .catch((error) => {
        console.log(error);
      });




  },
  // or use computed
  computed: {
    getViewJobDescription() {
      return this.JobDesp.JobDescription;
    },
    getJobPositionId() {
      return this.$route.params.id;
    },
    routes() {
      return this.$router.options.routes;
    }
  },
};
</script>

<style scoped>
label {
  display: inline-block;
  margin-bottom: 0.5rem;
}
/* .custom-file {
    position: relative;
    display: inline-block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    margin-bottom: 0;
}

.custom-file-input {
    position: relative;
    z-index: 2;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    margin: 0;
    opacity: 0;
}
.custom-file-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.custom-file-label {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}
.custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(1.5em + 0.75rem);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    content: "Browse";
    background-color: #e9ecef;
    border-left: inherit;
    border-radius: 0 0.25rem 0.25rem 0;
}

.custom-file-input:lang(en)~.custom-file-label::after {
    content: "Browse";
} */
</style>